import { withRouter, useParams } from "react-router";
import { IFiscalizacion, IItemsFiscalizacion, fetchFinalizarFiscalizacion, fetchObtenerFiscalizacion } from "../services/Fiscalizacion/Fiscalizacion";
import { 
IonContent, 
IonPage, 
IonButton, 
useIonToast,
IonSpinner
} from "@ionic/react";

import Header from "../../src/components/HeaderGenerico";
import { closeOutline } from "ionicons/icons";
import { useHistory } from 'react-router-dom';

import "./Fiscalizacion.css";
import { useEffect, useState } from "react";
import BotonArea from "../../src/components/Fiscalizacion/BotonArea";
import React from "react";
import { useFiscalizacion } from "src/components/Fiscalizacion/FiscalizacionContext";
import RelevamientoRutinaFiscalizacion from "src/components/Fiscalizacion/RelevamientoRutinaFiscalizacion";
import HistorialFiscalizaciones from "src/components/Fiscalizacion/HistorialFiscalizaciones";
interface Params {
    puntoservicio_id: string;
    fiscalizacion_id: string;
    nombre: string;
    objeto: string;
    codigo: string;
    cod_id: string;
}

const FiscalizarInicio: React.FC = (props:any) => {
    const history = useHistory();
    const [loading, setloading] = useState(true);
    const [fiscalizacion, setFiscalizacion] = useState<IFiscalizacion | undefined>(undefined);
    const {  limpiarInformacionFiscalizacion } = useFiscalizacion();     const [present] = useIonToast();
    
    const { ob_objetivo, ps_objeto, ps_id, fis_id, opciones } = fiscalizacion || {}
    const cod_id = opciones?.map((opcion: IItemsFiscalizacion) => opcion.codigo)

    const {puntoservicio_id, nombre, codigo } = useParams<Params>();

    async function obtenerFiscalizacion() {    
        if (puntoservicio_id) {  
            const resultado = await fetchObtenerFiscalizacion(+puntoservicio_id);
            if (resultado.error) {
                setFiscalizacion(undefined);
                setloading(false);
                present(resultado.error, 6000);
                console.error('Error al obtener la fiscalización:', resultado.error);
            } else {
                setFiscalizacion(resultado.fiscalizacion);
                setloading(false);
            }
        } else{
            setFiscalizacion(undefined);
            setloading(false);
            present('Ocurrió un error', 6000);
        }
    }
    
    const iniciarFiscalizacion = (url: string, ps_id: string, cod_id:string) => {
        props.history.push(`/${url}/${ps_id}/${nombre}/${codigo}/${fis_id}/${ob_objetivo}/${cod_id}`);
    }

     useEffect( () => {
        obtenerFiscalizacion();
    }, [puntoservicio_id])
    
  
        
    const botonCerrar = {
        icono: closeOutline,
        action: () => history.goBack(),
      }

      const handleCloseProcess = async () => {
       const response = await fetchFinalizarFiscalizacion(fiscalizacion?.fis_id as number)
       if (response.error) {
        present(response.error, 6000);
        console.error('Error al finalizar la fiscalización:', response.error);
        return;
      }
      present('Fiscalización finalizada', 6000);
      limpiarInformacionFiscalizacion();
      history.goBack();
      
      }

    const verResumen = () => {
        props.history.push(`/resumenfiscalizacion/${ps_id}/${nombre}/${codigo}/${fis_id}/${ob_objetivo}`);
    }
    return (
        <IonPage>
            <Header titulo="Fiscalización" marginTop="15px" botonIzq={botonCerrar} />

            <IonContent id="fiscalizacion">
            <div className="fisContainer">

                {loading ? 
                    <div className="spinner-container">
                        <IonSpinner /> 
                    </div>
                    
                    :

                    fiscalizacion ? 
                    <div className="fisCard">
                        <div className="fisCard_title">
                            <h1>{nombre}</h1>
                            <h4>{ps_objeto}</h4>
                        </div>
                        <div className="fisObj">
                            <h5>Objetivo:</h5>
                            <h6>{ob_objetivo}</h6>
                        </div>
                        <RelevamientoRutinaFiscalizacion/>
                        <div className="fiscalizaciones">
                            <h4>¿Qué área deseas fiscalizar?</h4> 
                            <div className="fisRow">
                                {fiscalizacion.opciones.map((item) => {
                                    // Mapear área -> tipo_comentario (AE_F_Tipo_Comentario)
                                    // Prioridad: id conocido -> código COD* -> texto.
                                    const codigo = (item.codigo || '').toUpperCase();
                                    const nombre = (item.opcion || '').toLowerCase();
                                    const codComentario =
                                        item.id === 1 ? '3' : // Personal
                                        item.id === 2 ? '4' : // Depósito
                                        item.id === 3 ? '5' : // Máquinas
                                        item.id === 4 ? '6' : // Limpieza Profunda
                                        item.id === 5 ? '1' : // Opinión Cliente
                                        item.id === 6 ? '8' : // Stock
                                        codigo === 'COD1' ? '3' :
                                        codigo === 'COD2' ? '4' :
                                        codigo === 'COD3' ? '5' :
                                        codigo === 'COD4' ? '6' :
                                        codigo === 'COD5' ? '1' :
                                        codigo === 'COD6' ? '8' :
                                        nombre.includes('personal') ? '3' :
                                        nombre.includes('deposito') ? '4' :
                                        nombre.includes('depósito') ? '4' :
                                        nombre.includes('maquina') ? '5' :
                                        nombre.includes('máquina') ? '5' :
                                        nombre.includes('limpieza') ? '6' :
                                        nombre.includes('opinion') ? '1' :
                                        nombre.includes('opinión') ? '1' :
                                        nombre.includes('stock') ? '8' :
                                        item.codigo; // Fallback

                                    return (
                                        <BotonArea
                                        key={item.codigo}
                                        cod_ID={parseInt(item.codigo)}
                                        id={item.id}
                                        iniciarFiscalizacion={(url: string) => iniciarFiscalizacion(url, ps_id as unknown as string, codComentario )}
                                        opcion={""}
                                        ob_id={0}
                                        fis_id={fis_id as number}
                                        ps_id={ps_id as number}
                                        ps_nombre={""}
                                        ps_objeto={""}
                                        opciones={cod_id as []}                                   
                                      />
                                    );
                                })}
                            
                            </div>
                            <div className="fisCard_foot">
                            <IonButton expand="block" onClick={handleCloseProcess}>FINALIZAR FISCALIZACIÓN</IonButton> 
                            </div>
                        </div>
                    </div>
                    :
                    <p>no se pudo obtener fiscalización</p>
                }

                        <div id="resumenFiscalizacion" className="fisResumen">
                            <IonButton expand="block" onClick={verResumen}>VER RESUMEN</IonButton>
                        </div>

                        {puntoservicio_id && <HistorialFiscalizaciones psId={+puntoservicio_id} />}
             </div>
            </IonContent>
        </IonPage>
    );
};

export default withRouter(FiscalizarInicio);
